import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Clock, QrCode, User } from 'lucide-react'
import { TabBar, type TabItem } from '@/components/app/tab-bar'
import { requireSpace } from '@/lib/guards'

export const Route = createFileRoute('/_fidele')({
  beforeLoad: () => requireSpace('/mon-qr'),
  component: FideleLayout,
})

const TABS: TabItem[] = [
  { to: '/mon-qr', label: 'Mon QR', icon: QrCode },
  { to: '/mes-presences', label: 'Présences', icon: Clock },
  { to: '/mon-profil', label: 'Profil', icon: User },
]

function FideleLayout() {
  return (
    <>
      <Outlet />
      <TabBar items={TABS} />
    </>
  )
}
